module.exports = __webpack_public_path__ + "static/media/icon_stay_active.f087747c.svg";